import { Component, ChangeDetectorRef, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { SFLLocation } from '@shared/data';

import 'jquery-locationpicker/src/locationpicker.jquery';

declare const $: any;

@Component({
  selector: 'location-picker',
  styles: [require('./location-picker.component.scss')],
  template: require('./location-picker.component.html')
})
export class LocationPickerComponent implements AfterViewInit {
  @Input()
  public location: SFLLocation;

  @Output()
  public locationChange: EventEmitter<SFLLocation>;

  public locationObject: any;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.locationChange = new EventEmitter();
  }

  public ngAfterViewInit(): void {
    let me = this;

    setTimeout(() => {
      $('#location-picker').locationpicker({
        location: {
          latitude: this.location.geoPoint.latitude,
          longitude: this.location.geoPoint.longitude
        },
        radius: 0,
        inputBinding: {
          locationNameInput: $('#input-address')
        },
        enableAutocomplete: true,
        onchanged(currentLocation, radius, isMarkerDropped) {
          me.locationObject = $(this).locationpicker('map').location;
          me.changeDetectorRef.detectChanges();

          me.location.city = me.locationObject.addressComponents.city;
          me.location.country = me.locationObject.addressComponents.country;
          me.location.addressLine1 = me.locationObject.addressComponents.addressLine1;
          me.location.geoPoint.latitude = parseFloat(me.locationObject['latitude']);
          me.location.geoPoint.longitude = parseFloat(me.locationObject['longitude']);
          me.locationChange.emit(me.location);
          console.log(me.location);
        },
        oninitialized(component) {
          me.locationObject = $(component).locationpicker('map').location;
          me.changeDetectorRef.detectChanges();
        }
      });
    }, 1000);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/location-picker/location-picker.component.ts